import cx from "classnames"
import React from "react"
import Link from "components/Link"

function NavPanel({ pos, items }) {
  if (items && items.length > 0) {
    return (
      <div
        className={cx(
          "bg-gradient-tulum absolute -mt-1 hidden animate-fade-in-up overflow-hidden rounded-1x border-l border-b border-r border-sage pt-1 shadow-simple group-hover:block",
          pos === "LEFT" ? "-left-8" : "-right-8"
        )}
      >
        <ul className="min-w-[350px] overflow-hidden rounded-tl-1x rounded-tr-1x bg-white">
          {items.map(({ label, description, path, icon }) => (
            <Link
              href={path}
              className={cx(
                "group-link hover:bg-gradient-menu relative flex px-3",
                description ? "py-4" : "items-center py-2"
              )}
              key={label}
            >
              {icon && (
                <div
                  className={cx(
                    "mr-4 flex flex-shrink-0 justify-center",
                    description ? "w-14 items-start" : "ml-3 w-10 items-center"
                  )}
                >
                  <img src={icon} alt={label} />
                </div>
              )}
              <div>
                <h3 className="inline-block text-base font-bold text-lush transition-colors group-link-hover:text-gossamer">
                  {label}
                </h3>
                {description && (
                  <p className="text-sm font-normal text-anchor">
                    {description}
                  </p>
                )}
              </div>
              <div className="bg-gradient-tulum absolute left-0 top-0 h-px w-full opacity-0 transition-opacity group-link-first:hidden group-link-hover:opacity-20" />
              <div className="bg-gradient-tulum absolute left-0 bottom-0 h-px w-full opacity-0 transition-opacity group-link-last:hidden group-link-hover:opacity-20" />
            </Link>
          ))}
        </ul>
      </div>
    )
  }
  return null
}

export default NavPanel
